import { render } from "./acceptWalletSharks.vue?vue&type=template&id=6dc415e9&scoped=true"
import script from "./acceptWalletSharks.vue?vue&type=script&lang=js"
export * from "./acceptWalletSharks.vue?vue&type=script&lang=js"

import "./acceptWalletSharks.vue?vue&type=style&index=0&id=6dc415e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc415e9"]])

export default __exports__